import dynamic from 'next/dynamic';

import {
  WIDGET_TEMPLATES as TEMPLATES,
  WIDGET_TYPES as TYPES,
} from './constants';
import { MediaRailSkeleton } from '@/components/organisms/MediaRail';

import type { WidgetPlugin } from './types';
import type { MediaRailProps } from '@/components/organisms/MediaRail';

export const MediaRailPlugin: WidgetPlugin<MediaRailProps> = {
  type: TYPES.CONTENT_SELECTION,
  template: TEMPLATES.MEDIA_RAIL,
  component: dynamic(
    () => import('@/components/organisms/MediaRail').then(mod => mod.MediaRail),
    { loading: MediaRailSkeleton },
  ),
  mapProps: widget => {
    const contentType = widget.content_parameters?.content_type;
    return {
      title: widget.title as string,
      contentType,
      items:
        widget.template.items?.map(item => ({
          id: String(item.id),
          title: item.title,
          description: item.short_description ?? '',
          poster: item.poster?.url
            ? item.poster
            : item.art_work?.url
              ? item.art_work
              : undefined,
          videoGif: item.preview?.gif?.url
            ? item.preview.gif
            : item.preview?.animated_thumbnail?.url
              ? item.preview.animated_thumbnail
              : item.art_work?.url
                ? item.art_work
                : undefined,
          // TODO: clip is currently a sibling of preview in the API payload — backend should move it to preview.clip
          videoClip: item.clip?.playback_id ? item.clip : undefined,
          link: item.link || `/${contentType}/${item.id}`,
          slug: item.slug,
        })) ?? [],
      ...(widget.template.configuration?.view_all === true
        ? { showAllURL: `?seeAll&widgetId=${widget.id}` }
        : {}),
    };
  },
};
